import * as Yup from "yup";
import { useAddressValidator } from "../shared/components/address-select/validator";
import useBirthDateValidator from "../shared/components/birth-date/validator";
import { useTextInputValidator } from "../shared/components/formik/text-input/validator";
import useGenderValidator from "../shared/components/gender/validator";
import { useMandatoryStringTypeValidator } from "../shared/components/validator";

export default function useSigningValidationSchema() {
  const validatePerson = Yup.object().shape({
    gender: useGenderValidator(),
    firstName: useTextInputValidator(),
    lastName: useTextInputValidator(),
    nationality: useMandatoryStringTypeValidator(),
    birthdate: useBirthDateValidator(),
    fullStreet: useTextInputValidator(),
    address: useAddressValidator(),
  });

  return Yup.object().shape({
    cardholderSignatories: Yup.array().when("isSameAsCardholder", {
      is: "yes",
      then: () => Yup.array().of(validatePerson),
    }),
    otherSignatories: Yup.array().when("isSameAsCardholder", {
      is: "no",
      then: () => Yup.array().of(validatePerson),
    }),
  });
}
